import { makeRule } from '@core/utils/rule.js'

export let searchRules = {
  id: [
    {...makeRule('请输入正确的taskID', 'integer', 'blur', false), min: 1},
  ],
}

export let exportCoverageCfgRules = {
  user_finish_time_range: [
    {...makeRule('请选择时间范围,允许范围 2015-01-01 至今', 'array', 'blur', true)},
  ],
  distance_range: [
    {...makeRule('请填写距离范围层级', 'array', 'blur', true)},
  ],
}

const validateTitle = (rule, value, callback) => {
  if (value.indexOf('测试') !== -1) {
    callback(new Error('请勿在任务标题中使用“测试”字样'))
  } else {
    callback()
  }
}

export let formRules = {
  title: [
    {...makeRule('请输入任务标题')},
    {...makeRule('请输入2-255个字符', 'string'), min: 2, max: 255},
    {validator: validateTitle, trigger: 'blur'}
  ],
  salary: [
    {...makeRule('请输入任务报酬', 'number')},
  ],
  points: [
    {...makeRule('请输入任务零豆', 'integer', ['change', 'blur'])},
    {...makeRule('请输入正整数', 'integer', ['change', 'blur']), min: 0},
  ],
  hirenum: [
    {...makeRule('请输入任务需要人数', 'integer')},
    {...makeRule('请输入大于0的整数', 'integer'), min: 1},
  ],
  validcheckindistance: [
    {...makeRule('请输入任务有效签到距离', 'number')},
    {...makeRule('请输入正确的格式', 'number'), min: 0},
  ],
  showtime: [
    {...makeRule('请输入任务预览开始时间')},
  ],
  starttime: [
    {...makeRule('请输入任务上线时间')},
  ],
  deadline: [
    {...makeRule('请输入任务下线时间')},
  ],
  taskendtime: [
    {...makeRule('请输入任务结束时间')},
  ],
  processingtime: [
    {...makeRule('请输入任务完成时间限制', 'integer')},
    {...makeRule('请输入正整数', 'integer'), min: 1},
  ],
  reviewtime: [
    {...makeRule('请输入任务审核时间', 'integer')},
    {...makeRule('请输入正整数', 'integer'), min: 1},
  ],
  minclientversionforandroid: [
    {...makeRule('请输入正确的版本号格式', 'string', 'blur', false), pattern: /^\d+.\d+.\d+$/},
  ],
  minclientversionforios: [
    {...makeRule('请输入正确的版本号格式', 'string', 'blur', false), pattern: /^\d+.\d+.\d+$/},
  ],
  minclientversionforandroid_clb: [
    {...makeRule('请输入正确的版本号格式', 'string', 'blur', false), pattern: /^\d+.\d+.\d+$/},
  ],
  minclientversionforios_clb: [
    {...makeRule('请输入正确的版本号格式', 'string', 'blur', false), pattern: /^\d+.\d+.\d+$/},
  ],
  customerid: [
    {...makeRule('请选择客户', 'integer')},
  ],
  projectid: [
    {...makeRule('请选择项目', 'integer')},
  ],
  batchid: [
    {...makeRule('请选择批次', 'integer')},
  ],
  templateid: [
    {...makeRule('请选择分步模板', 'integer')},
  ],
  dynamic_adjust_salary: [
    {...makeRule('请输入调价金额')},
    {...makeRule('请输入正确的格式'), pattern: /^[0-9]+(.[0-9]{2})?$/},
  ],
  areaIds: [
    {...makeRule('请选择任务区域', 'array')},
  ],
  marketid: [
    {...makeRule('请选择卖场', 'integer')},
  ],
}



// WEBPACK FOOTER //
// ./src/views/task/task.rules.js